module.exports = __webpack_public_path__ + "static/media/campo_mourao.1b351cf6.png";